import React, { Component } from 'react'
import { Row } from 'reactstrap'
import BootstrapTable from "react-bootstrap-table-next"
import ToolkitProvider from 'react-bootstrap-table2-toolkit'
import { IconeCarregar } from '../../../../comum/components/Icones'
import { CollapseItemTableIndicator } from '../../../../comum/components/CollapseItemTableIndicator';
import DetalhesOrcamentoExport from './DetalhesOrcamentoExport';
import { observer } from 'mobx-react'
import Tooltip from '../../../../comum/components/Tooltip';
import Checkbox from '../../../../comum/components/Checkbox';
import LoadingImage from '../../../../comum/components/LoadingImage'
import CardExportacao from './CardExportacao'

@observer
export default class TabelaOrcamentoExport extends Component {

    constructor(props) {
        super(props)

        this.controller = this.props.controller

    }

    render() {
        const selectRow = {
            mode: 'checkbox',
            nonSelectable: this.controller.listaNaoSelecionados,
            selectionHeaderRenderer: ({ indeterminate, ...rest }) => (
                <Tooltip tooltipText={`Clique aqui para ${rest.checked || indeterminate ? "desmarcar" : "selecionar"} todos os registros`}>
                    <Checkbox ativo={rest.checked} onClick={() => { }} />
                </Tooltip>
            ),
            selectionRenderer: ({ mode, rowIndex, ...rest }) =>
                <Checkbox ativo={this.controller.listaExportacao[rowIndex].Pagar} onClick={() => { }} bloqueado={rest.disabled} />,
            onSelect: (row, isSelect, rowIndex, e) => {
                e.preventDefault()
                e.stopPropagation()
                this.controller.selecionar(row)
            },
            onSelectAll: (isSelect, rows, e) => {
                e.preventDefault()
                e.stopPropagation()

                this.controller.selecionarTodos(isSelect)
                if (isSelect) {
                    const selecao = this.controller.listaExportacao.filter((item, index) => item.HabilitarPagamento).map(item => item.Id)
                    return selecao
                } else {
                    return []
                }
            },
        }
        if (this.controller.loading) {
            return <LoadingImage />
        } else if (this.controller.listaExportacao.length === 0) {
            return <span className="mensagem-filtrar">{this.controller.tableMessage}</span>
        } else {
            return (
                <div>{
                    window.innerWidth > 991
                        ? <ToolkitProvider
                            keyField="Id"
                            data={[...this.controller.listaExportacao]}
                            columns={[...this.controller.colunas]}
                        >
                            {props => <div>
                                <BootstrapTable bootstrap4
                                    striped
                                    bordered={false}
                                    noDataIndication={this.controller.tableMessage}
                                    classes="tabela tabela-layout cabotagem"
                                    // expandRow={detalhesRow}
                                    selectRow={selectRow}
                                    {...props.baseProps}
                                />
                            </div>}
                        </ToolkitProvider>
                        : this.controller.listaExportacao.map(item => <CardExportacao
                            key={item.Id}
                            controller={this.controller}
                            data={item}
                            id={item.Id}
                            click={this.controller.selecionar}
                            colunas={[...this.controller.colunas]}
                            // outrosDados={[...this.controller.outrosDados]}
                            titulo={"OsId"}
                        />)
                }
                </div>
            )
        }

    }
}



// WEBPACK FOOTER //
// ./src/modules/faturamento/orcamento/exportacao/components/TabelaOrcamentoExport.js